/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleRentalRequest
 */
export interface VehicleRentalRequest {
    /**
     * Vehicle rental ID (required for updates, ignored on create).
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    gondolaBookingId?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    providerBookingId?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    vendorCode?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    vendorName?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    pickupLocationCode?: string;
    /**
     * Travelport classification of the booked pickup desk ("Airport", "CityCenterDowntown", "City", ...). Absent means unknown, which clients treat as an airport pickup. Anything else means pickup_location_code is only the metro the desk sits in, so render the address instead of a "<code> Airport" label.
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    pickupLocationType?: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleRentalRequest
     */
    pickupDatetime?: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    dropoffLocationCode?: string;
    /**
     * Travelport classification of the booked dropoff desk. Same semantics as pickup_location_type.
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    dropoffLocationType?: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleRentalRequest
     */
    dropoffDatetime?: Date;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    acrissCode?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    vehicleClass?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    vehicleCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    vehicleDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    transmissionType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleRentalRequest
     */
    airConditioning?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleRentalRequest
     */
    passengerCount?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleRentalRequest
     */
    bagCount?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleRentalRequest
     */
    totalRate?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleRentalRequest
     */
    dailyRate?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    billingCurrency?: string;
    /**
     * Rental counter location (e.g., "Terminal 1, Level 1")
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    pickupCounterLocation?: string;
    /**
     * Shuttle service details (e.g., "Complimentary shuttle every 10 minutes")
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    pickupShuttleInfo?: string;
    /**
     * Street address of the rental facility
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    pickupAddress?: string;
    /**
     * Phone number for the rental location
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    pickupPhone?: string;
    /**
     * Counter location at the dropoff facility (e.g., "Terminal 1, Level 1")
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    dropoffCounterLocation?: string;
    /**
     * Shuttle service details for the dropoff location
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    dropoffShuttleInfo?: string;
    /**
     * Street address of the dropoff facility
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    dropoffAddress?: string;
    /**
     * Phone number for the dropoff location
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    dropoffPhone?: string;
    /**
     * Cancellation policy text from the rental car vendor, captured at booking time.
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    cancellationPolicy?: string;
    /**
     * Whether this vehicle rental is opted in to auto-save (rate monitoring and rebooking).
     * @type {boolean}
     * @memberof VehicleRentalRequest
     */
    autoSave?: boolean;
    /**
     * Mark the vehicle rental as cancelled in Gondola's records. Does not call the supplier.
     * @type {boolean}
     * @memberof VehicleRentalRequest
     */
    cancelled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    bookingAgent?: string;
    /**
     * 
     * @type {Date}
     * @memberof VehicleRentalRequest
     */
    bookingDate?: Date;
    /**
     * Rental confirmation number. Identity/dedup key for manually-added and email-parsed rentals.
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    confirmationNumber?: string;
    /**
     * URL of the vehicle image from the supplier.
     * @type {string}
     * @memberof VehicleRentalRequest
     */
    imageUrl?: string;
}

/**
 * Check if a given object implements the VehicleRentalRequest interface.
 */
export function instanceOfVehicleRentalRequest(value: object): value is VehicleRentalRequest {
    return true;
}

export function VehicleRentalRequestFromJSON(json: any): VehicleRentalRequest {
    return VehicleRentalRequestFromJSONTyped(json, false);
}

export function VehicleRentalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleRentalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'gondolaBookingId': json['gondola_booking_id'] == null ? undefined : json['gondola_booking_id'],
        'providerBookingId': json['provider_booking_id'] == null ? undefined : json['provider_booking_id'],
        'vendorCode': json['vendor_code'] == null ? undefined : json['vendor_code'],
        'vendorName': json['vendor_name'] == null ? undefined : json['vendor_name'],
        'pickupLocationCode': json['pickup_location_code'] == null ? undefined : json['pickup_location_code'],
        'pickupLocationType': json['pickup_location_type'] == null ? undefined : json['pickup_location_type'],
        'pickupDatetime': json['pickup_datetime'] == null ? undefined : (new Date(json['pickup_datetime'])),
        'dropoffLocationCode': json['dropoff_location_code'] == null ? undefined : json['dropoff_location_code'],
        'dropoffLocationType': json['dropoff_location_type'] == null ? undefined : json['dropoff_location_type'],
        'dropoffDatetime': json['dropoff_datetime'] == null ? undefined : (new Date(json['dropoff_datetime'])),
        'acrissCode': json['acriss_code'] == null ? undefined : json['acriss_code'],
        'vehicleClass': json['vehicle_class'] == null ? undefined : json['vehicle_class'],
        'vehicleCategory': json['vehicle_category'] == null ? undefined : json['vehicle_category'],
        'vehicleDescription': json['vehicle_description'] == null ? undefined : json['vehicle_description'],
        'transmissionType': json['transmission_type'] == null ? undefined : json['transmission_type'],
        'airConditioning': json['air_conditioning'] == null ? undefined : json['air_conditioning'],
        'passengerCount': json['passenger_count'] == null ? undefined : json['passenger_count'],
        'bagCount': json['bag_count'] == null ? undefined : json['bag_count'],
        'totalRate': json['total_rate'] == null ? undefined : json['total_rate'],
        'dailyRate': json['daily_rate'] == null ? undefined : json['daily_rate'],
        'billingCurrency': json['billing_currency'] == null ? undefined : json['billing_currency'],
        'pickupCounterLocation': json['pickup_counter_location'] == null ? undefined : json['pickup_counter_location'],
        'pickupShuttleInfo': json['pickup_shuttle_info'] == null ? undefined : json['pickup_shuttle_info'],
        'pickupAddress': json['pickup_address'] == null ? undefined : json['pickup_address'],
        'pickupPhone': json['pickup_phone'] == null ? undefined : json['pickup_phone'],
        'dropoffCounterLocation': json['dropoff_counter_location'] == null ? undefined : json['dropoff_counter_location'],
        'dropoffShuttleInfo': json['dropoff_shuttle_info'] == null ? undefined : json['dropoff_shuttle_info'],
        'dropoffAddress': json['dropoff_address'] == null ? undefined : json['dropoff_address'],
        'dropoffPhone': json['dropoff_phone'] == null ? undefined : json['dropoff_phone'],
        'cancellationPolicy': json['cancellation_policy'] == null ? undefined : json['cancellation_policy'],
        'autoSave': json['auto_save'] == null ? undefined : json['auto_save'],
        'cancelled': json['cancelled'] == null ? undefined : json['cancelled'],
        'bookingAgent': json['booking_agent'] == null ? undefined : json['booking_agent'],
        'bookingDate': json['booking_date'] == null ? undefined : (new Date(json['booking_date'])),
        'confirmationNumber': json['confirmation_number'] == null ? undefined : json['confirmation_number'],
        'imageUrl': json['image_url'] == null ? undefined : json['image_url'],
    };
}

export function VehicleRentalRequestToJSON(json: any): VehicleRentalRequest {
    return VehicleRentalRequestToJSONTyped(json, false);
}

export function VehicleRentalRequestToJSONTyped(value?: VehicleRentalRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'gondola_booking_id': value['gondolaBookingId'],
        'provider_booking_id': value['providerBookingId'],
        'vendor_code': value['vendorCode'],
        'vendor_name': value['vendorName'],
        'pickup_location_code': value['pickupLocationCode'],
        'pickup_location_type': value['pickupLocationType'],
        'pickup_datetime': value['pickupDatetime'] == null ? value['pickupDatetime'] : value['pickupDatetime'].toISOString(),
        'dropoff_location_code': value['dropoffLocationCode'],
        'dropoff_location_type': value['dropoffLocationType'],
        'dropoff_datetime': value['dropoffDatetime'] == null ? value['dropoffDatetime'] : value['dropoffDatetime'].toISOString(),
        'acriss_code': value['acrissCode'],
        'vehicle_class': value['vehicleClass'],
        'vehicle_category': value['vehicleCategory'],
        'vehicle_description': value['vehicleDescription'],
        'transmission_type': value['transmissionType'],
        'air_conditioning': value['airConditioning'],
        'passenger_count': value['passengerCount'],
        'bag_count': value['bagCount'],
        'total_rate': value['totalRate'],
        'daily_rate': value['dailyRate'],
        'billing_currency': value['billingCurrency'],
        'pickup_counter_location': value['pickupCounterLocation'],
        'pickup_shuttle_info': value['pickupShuttleInfo'],
        'pickup_address': value['pickupAddress'],
        'pickup_phone': value['pickupPhone'],
        'dropoff_counter_location': value['dropoffCounterLocation'],
        'dropoff_shuttle_info': value['dropoffShuttleInfo'],
        'dropoff_address': value['dropoffAddress'],
        'dropoff_phone': value['dropoffPhone'],
        'cancellation_policy': value['cancellationPolicy'],
        'auto_save': value['autoSave'],
        'cancelled': value['cancelled'],
        'booking_agent': value['bookingAgent'],
        'booking_date': value['bookingDate'] == null ? value['bookingDate'] : value['bookingDate'].toISOString(),
        'confirmation_number': value['confirmationNumber'],
        'image_url': value['imageUrl'],
    };
}

